export default {
  name: "Star",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    "fill-rule": "evenodd",
    d:
      "M16.97 2.68a1.05 1.05 0 0 0-1.95 0l-3.24 7.88c-.15.37-.5.62-.89.65l-8.42.68c-.94.08-1.31 1.26-.6 1.87l6.41 5.55c.3.26.43.67.34 1.06l-1.96 8.3c-.22.92.78 1.65 1.58 1.16l7.21-4.45c.34-.21.76-.21 1.1 0l7.21 4.45c.8.49 1.79-.23 1.58-1.16l-1.96-8.3c-.09-.39.04-.8.34-1.06l6.41-5.55c.71-.62.33-1.8-.6-1.87l-8.42-.68c-.39-.03-.74-.28-.89-.65l-3.25-7.88zM16 5.86l-2.27 5.51a3.181 3.181 0 0 1-2.67 1.96l-5.89.48 4.49 3.88c.9.78 1.3 2 1.02 3.17l-1.37 5.81 5.04-3.11c1.01-.63 2.29-.63 3.3 0l5.04 3.11-1.37-5.81c-.28-1.17.12-2.39 1.02-3.17l4.49-3.88-5.89-.48c-1.18-.1-2.21-.85-2.67-1.96L16 5.86z",
    "clip-rule": "evenodd",
  },
}
